
import React from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Card, CardContent } from "@/components/ui/card";
import { EmailTemplateType } from '@/utils/email-templates/types';
import { generateTemplateGroups } from '@/utils/email-templates/templateCategories';

interface TemplateSelectorProps {
  selectedTemplate: EmailTemplateType;
  onTemplateChange: (templateKey: EmailTemplateType) => void;
  onValidate: () => void;
  onSave: () => void;
  isLoading: boolean;
}

export const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  selectedTemplate,
  onTemplateChange,
  onValidate,
  onSave,
  isLoading
}) => {
  // Generate template groups dynamically from available email templates
  const templateGroups = generateTemplateGroups();

  return (
    <Card>
      <CardContent className="pt-4 space-y-4">
        <div className="flex flex-col space-y-2">
          <Label>Select Template:</Label>
          <Select 
            value={selectedTemplate}
            onValueChange={(value) => onTemplateChange(value as EmailTemplateType)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select a template" />
            </SelectTrigger>
            <SelectContent>
              {templateGroups.map((group) => (
                <React.Fragment key={group.label}>
                  <div className="py-2 pl-2 text-sm text-muted-foreground font-semibold">{group.label}</div>
                  {group.templates.map((template) => (
                    <SelectItem key={template.value} value={template.value}>
                      {template.label}
                    </SelectItem>
                  ))}
                </React.Fragment>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex space-x-2 mt-4">
          <Button onClick={onValidate} variant="outline" type="button">
            Validate Template
          </Button>
          <Button onClick={onSave} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save Template'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
